<template>
<!--  <scale-box :width="1920" :height="1080" bgc="transparent" :delay="100">-->
    <a-config-provider :locale="locale">
      <div id="app">
        <router-view  class="largeScreen-contents" />
      </div>
    </a-config-provider>
<!--  </scale-box>-->
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import Loading from './components/GlobalLoad/GlobalLoad' // 全局Loading组件
import { mapState } from 'vuex' // 引入vuex状态管理，mapState管理中存在全局loading
import ScaleBox from "vue2-scale-box";
import {conf_list} from "@/api/manage";
export default {
  data () {
    return {
      locale: zhCN
    }
  },
  created() {
    conf_list({}).then((response) => {
      var obj = response.data;
      obj = JSON.stringify(obj);
      localStorage.setItem('configdata', obj)
    });
  //
  },
  mounted: function() {
    // 页面开始加载时修改font-size
    var html = document.getElementsByTagName("html")[0];
    var oWidth = document.body.clientWidth || document.documentElement.clientWidth;
    // 这里的750是指设计图的大小,自己根据实际情况改变
    html.style.fontSize = oWidth / 750 * 100 + "px";
    console.log('rem:', html.style.fontSize);
  },
  components: {
    Loading, // 注册全局loading 组件
    ScaleBox
  },
  computed: {

    // 全局 loading
		...mapState([
			'globalLoading'
		])
	}
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
.el-checkbox.is-bordered.is-checked {
  border-color:red;
}
.el-radio.is-bordered.is-checked {
  border-color: red;
}
.el-checkbox__input.is-checked+.el-checkbox__label {
  color:red;
}
.el-radio__input.is-checked+.el-radio__label {
  color:red;
}

.el-radio__input.is-checked .el-radio__inner {
  border-color:red;
  background:red;
}

.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color:red;
  border-color:red;
}

.el-button--primary {
  color: #FFF;
  background-color:red;
  border-color: red;
}

.el-button--primary:focus, .el-button--primary:hover {
  background:red;
  border-color:red;
  color: #FFF;
}

.launchButtonBox{
  right: 45px !important;
  bottom: 187px !important;
}


</style>
